const INVOICE_NO_DEFAULT_WIDTH = 110;
const INVOICE_NO_TEXT_FONT = 'normal 14px sans-serif';
const INVOICE_NO_CELL_PADDING = 28;
const INVOICE_NO_QBO_PADDING = 38; // icon (16px) + gap (22px)
const INVOICE_NO_EXTRA_PADDING = 20; // to fix custom scroll issue appearing

export const getTextWidth = (text, font) => {
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;

  return context.measureText(text).width;
};

// Set the Width of the Column Based on the Content
// https://www.telerik.com/kendo-react-ui/components/knowledge-base/grid-column-auto-width
export const calculateInvoiceNoColumnWidth = (data, showQbInvoiceNumberColumn = false) => {
  if (!data.length) return INVOICE_NO_DEFAULT_WIDTH;

  const contentMaxWidth = data.reduce((maxWidth, item) => {
    const text = showQbInvoiceNumberColumn
      ? `${item.invoiceNo || ''}`
      : `${item.invoiceNo || ''}${item.qboInvoiceId || ''}`;
    const width =
      getTextWidth(text, INVOICE_NO_TEXT_FONT) +
      INVOICE_NO_CELL_PADDING +
      (item.qboInvoiceId && !showQbInvoiceNumberColumn ? INVOICE_NO_QBO_PADDING : 0) +
      INVOICE_NO_EXTRA_PADDING;

    return Math.max(maxWidth, width);
  }, 0);

  return Math.max(contentMaxWidth, INVOICE_NO_DEFAULT_WIDTH);
};
